body {
  margin: 0;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',
    'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',
    sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  background-color: #f5f5f5;
}

code {
  font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New',
    monospace;
}

.container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 20px;
}

.header {
  background: white;
  padding: 20px;
  border-radius: 8px;
  margin-bottom: 20px;
  box-shadow: 0 2px 4px rgba(0,0,0,0.1);
}

.status-panel {
  display: flex;
  gap: 20px;
  margin-bottom: 20px;
}

.status-card {
  background: white;
  padding: 15px;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0,0,0,0.1);
  flex: 1;
}

.status-indicator {
  width: 12px;
  height: 12px;
  border-radius: 50%;
  display: inline-block;
  margin-right: 8px;
}

.status-healthy {
  background-color: #4caf50;
}

.status-unhealthy {
  background-color: #f44336;
}

.session-panel {
  background: white;
  padding: 20px;
  border-radius: 8px;
  margin-bottom: 20px;
  box-shadow: 0 2px 4px rgba(0,0,0,0.1);
}

.session-form {
  display: grid;
  gap: 15px;
  margin-bottom: 20px;
}

.form-group {
  display: flex;
  flex-direction: column;
  gap: 5px;
}

.form-group label {
  font-weight: 600;
  color: #333;
}

.form-group input,
.form-group textarea {
  padding: 10px;
  border: 1px solid #ddd;
  border-radius: 4px;
  font-size: 14px;
}

.form-group textarea {
  min-height: 80px;
  resize: vertical;
}

.button {
  padding: 10px 20px;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-size: 14px;
  font-weight: 600;
  transition: background-color 0.2s;
}

.button-primary {
  background-color: #2196f3;
  color: white;
}

.button-primary:hover {
  background-color: #1976d2;
}

.button-danger {
  background-color: #f44336;
  color: white;
}

.button-danger:hover {
  background-color: #d32f2f;
}

.button:disabled {
  background-color: #ccc;
  cursor: not-allowed;
}

.chat-container {
  background: white;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0,0,0,0.1);
  height: 500px;
  display: flex;
  flex-direction: column;
}

.chat-messages {
  flex: 1;
  padding: 20px;
  overflow-y: auto;
  border-bottom: 1px solid #eee;
}

.message {
  margin-bottom: 15px;
  padding: 10px;
  border-radius: 8px;
  max-width: 80%;
}

.message-user {
  background-color: #e3f2fd;
  margin-left: auto;
  text-align: right;
}

.message-assistant {
  background-color: #f5f5f5;
  margin-right: auto;
}

.message-system {
  background-color: #fff3e0;
  margin: 0 auto;
  text-align: center;
  font-style: italic;
}

.message-header {
  font-size: 12px;
  color: #666;
  margin-bottom: 5px;
}

.message-content {
  font-size: 14px;
  line-height: 1.4;
}

.chat-input {
  padding: 20px;
  display: flex;
  gap: 10px;
}

.chat-input input {
  flex: 1;
  padding: 10px;
  border: 1px solid #ddd;
  border-radius: 4px;
  font-size: 14px;
}

.session-info {
  background: #e8f5e8;
  padding: 15px;
  border-radius: 4px;
  margin-bottom: 15px;
}

.session-info h3 {
  margin: 0 0 10px 0;
  color: #2e7d32;
}

.session-id {
  font-family: monospace;
  font-size: 12px;
  background: rgba(255,255,255,0.7);
  padding: 5px;
  border-radius: 3px;
}

.error {
  background: #ffebee;
  color: #c62828;
  padding: 10px;
  border-radius: 4px;
  margin-bottom: 15px;
}

.loading {
  text-align: center;
  padding: 20px;
  color: #666;
}
